export default __webpack_public_path__ + "static/media/logo.54dba8cc.png";